module.exports = __webpack_public_path__ + "static/media/ZUPC.86c2b923.pdf";